import { useTheme } from '@emotion/react'
import { motion } from 'framer-motion'

import { HeroTitleWrapper, HeroTitle } from '../Hero'

import { ReliabilityCell } from '~partials/reliability-calculator/UI'
import Image from '~components/Image'
import calculating from '~media/reliability-calculator/calculating.svg'

const Step10 = () => {
  const theme = useTheme()

  const variants = {
    hidden: {
      opacity: 0.25,
    },
    visible: (i) => ({
      opacity: 1,
      transition: {
        yoyo: Infinity,
        delay: i * theme.motion.timing.short,
      },
    }),
  }

  return (
    <ReliabilityCell
      css={{
        textAlign: 'center',
      }}
    >
      <HeroTitleWrapper className="u-contrast" bottomSpace>
        <HeroTitle>
          Calculating your reliability
          <motion.span
            initial="hidden"
            animate="visible"
            variants={variants}
            custom={1}
          >
            .
          </motion.span>
          <motion.span
            initial="hidden"
            animate="visible"
            variants={variants}
            custom={2}
          >
            .
          </motion.span>
          <motion.span
            initial="hidden"
            animate="visible"
            variants={variants}
            custom={3}
          >
            .
          </motion.span>
        </HeroTitle>
      </HeroTitleWrapper>
      <Image src={calculating} alt="" />
    </ReliabilityCell>
  )
}

export default Step10
